import React, {Component} from 'react';
import Modal from '../../../components/Modal/modal';
import Link from 'gatsby-link';

import config from 'data/merchants';


import youtubePreview from './images/youtube-preview.jpg';
import Image from 'components/Image'


class Entrepreneurs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }

  openModal = () => {
    this.setState({
      modal:true
    })
  };

  closeModal = () => {
    this.setState({
      modal:false
    })
  };

  renderModal() {
    if(this.state.modal) {
      return (
        <Modal
        close = {this.closeModal}
        >
          <iframe width="100%" height="330" src="https://www.youtube.com/embed/3yVwaGifrIE?rel=0&amp;showinfo=0"
                  frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
        </Modal>
      )
    }
    return null
  }

  render(){
    return(
      <section>
        <div className="bg-lightGrey py-5" style={{background: '#F6F6F6'}}>
          <div className="container marketingSection">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h2>WHY YOCO?</h2>
                <h3>Why more than {config.merchants} entrepreneurs love Yoco</h3>
                <p>Who better to tell it like it is than the people who use it everyday.</p>
                <span className="tinyLink" onClick={this.openModal} style={{cursor:'pointer'}}>Watch the video to find out more.</span>
              </div>
              <div className="col-md-8 text-center ">
                <Image src={youtubePreview} className="img-fluid" alt="" style={{maxWidth:"500px", cursor: "pointer"}} onClick={this.openModal}/>
              </div>
            </div>
          </div>
        </div>
        {this.renderModal()}
      </section>

    )
  }
}



export default Entrepreneurs


// WEBPACK FOOTER //
// ./src/sections/homePage/entrepreneurs/entrepreneurs.js